import { FC, useEffect, useMemo, useRef, useState } from "react";
import { CustomTextField } from "../InputParameters";
import { InputText, InputTextParameters } from "../InputText";
import {
    ChangeEvent,
    useCurrency as currencyFormatter,
} from "react-hook-currency";

interface InputMoneyProperties extends InputTextParameters, CustomTextField {
    isNumberValue?: boolean;
    sufixSymbol?: boolean;
}

const InputMoney: FC<InputMoneyProperties> = ({
    isNumberValue = false,
    fullWidth = true,
    sufixSymbol = false,
    onChangeValue,
    ...props
}) => {
    const { onChange: _onChange, onKeyDown, format } = useMemo(
        () => currencyFormatter({
            style: "decimal",
            precision: 2,
            locale: "pt-BR",
            currency: "BRL"
        }),
        [props]
    );

    const resolveDefaultValue = (value: number | string): string => {
        let _value: string = String(value)
        
        if (_value === "") {
            return "000"
        }

        const _decimalVal = _value.split(".");
        
        if (_decimalVal.length === 1) {
            return _value.replace(/^\D/g, "") + "00"
        }
        
        if (_decimalVal[1].length === 1) {
            return _value.replace(/^\D/g, "") + "0"
        }

        return _value
    }

    const [value, setValue] = useState(format(resolveDefaultValue(props.defaultValue)));


    useEffect(() => {
        setValue(format(resolveDefaultValue(props.value)))
    }, [props.value])

    const ref = useRef(null);

    return <InputText
        {...props}
        fullWidth={fullWidth}
        mask={"currency"}
        defaultValue={props?.defaultValue}
        ref={ref}
        prefix={<>R$ </>}
        maxLength={15}
        InputProps={{
            max: 200_000
        }}
        onChange={(e: any) => {
            _onChange(e as ChangeEvent);
            setValue(e.target.value);
            if (props.onChange) {
                props.onChange(e);
            }
            if (onChangeValue) {
                onChangeValue({
                    name: props?.name ? props?.name : null,
                    value: e.target.value,
                    numberValue: Number(Number(e.target.value.replace(/\./g, "").replace(/\,/g, ".")).toFixed(2))
                })
            }
        }}
        onKeyDown={(e: any) => {
            onKeyDown(e as any);
            setValue(e.target.value);
            if (props.onKeyDown) {
                props.onKeyDown(e);
            }
        }}

        value={value}
    />
}

export { InputMoney }